import {
  Component, Input, ViewChild, ElementRef,
  AfterViewInit, OnChanges, OnDestroy, OnInit
} from '@angular/core';
import { echarts, ECharts, EChartsCoreOption } from '../echarts.config';
// import type { PieSeriesOption } from 'echarts/charts';

@Component({
  selector: 'app-chart-semicircle',
  templateUrl: './chart-semicircle.component.html',
  styleUrls: ['./chart-semicircle.component.scss'],
  standalone: false
})
export class ChartSemicircleComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() porcentaje: number = 0;

  @ViewChild('container', { static: true }) container!: ElementRef;

  private chart: ECharts | null = null;
  private themeObserver!: MutationObserver;

  ngOnInit(): void {
    const html = document.documentElement;
    const body = document.body;

    if (html.classList.contains('app-dark')) {
      body.classList.add('app-dark');
    } else {
      body.classList.remove('app-dark');
    }

    this.themeObserver = new MutationObserver(() => {
      if (html.classList.contains('app-dark')) {
        body.classList.add('app-dark');
      } else {
        body.classList.remove('app-dark');
      }
      this.chart?.dispose();
      this.initChart();
    });

    this.themeObserver.observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  ngAfterViewInit(): void {
    this.initChart();
  }

  ngOnChanges(): void {
    if (this.chart) {
      this.updateChart();
    }
  }

  ngOnDestroy(): void {
    this.themeObserver?.disconnect();
    this.chart?.dispose();
  }

  private get isDark(): boolean {
    return document.body.classList.contains('app-dark');
  }

  private get pct(): number {
    return Math.round(Math.max(0, Math.min(100, this.porcentaje)));
  }

  private initChart(): void {
    this.container.nativeElement.innerHTML = '';

    const theme = this.isDark ? 'dark' : undefined;
    this.chart = echarts.init(this.container.nativeElement, theme);
    this.chart.setOption(this.buildOption());

    setTimeout(() => this.chart?.resize(), 0);
  }

  private updateChart(): void {
    if (!this.chart) return;
    this.chart.setOption(this.buildOption());
  }

  private buildOption(): EChartsCoreOption {
    const isDark = this.isDark;
    const pct = this.pct;
    const textColor = isDark ? '#fff' : '#111';
    const emptyColor = isDark ? '#374151' : '#e5e7eb';

    return {
      backgroundColor: 'transparent',
      title: [
        {
          text: this.title,
          left: 'left',
          top: 10,
          textStyle: { color: textColor, fontSize: 14 }
        },
        // Porcentaje centrado en el medio del semicírculo
        {
          text: `${pct}%`,
          left: 'center',
          top: '58%',
          textStyle: {
            fontSize: 22,
            fontWeight: 'bold',
            color: textColor
          }
        },
        ...(this.subtitle ? [{
          text: this.subtitle,
          left: 'center',
          top: '70%',
          textStyle: { color: textColor, fontSize: 12 }
        }] : [])
      ],
      tooltip: { show: false },
      series: [
        {
          type: 'pie',
          radius: ['55%', '85%'],
          center: ['50%', '75%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: pct,
              name: 'Valor',
              itemStyle: { color: '#2e7d6b', borderRadius: 4 }
            },
            {
              value: 100 - pct,
              name: '',
              itemStyle: { color: emptyColor },
              emphasis: { disabled: true },
              tooltip: { show: false }
            }
          ],
          label: { show: false },
          silent: false
        }
      ]
    };
  }
}